export default __webpack_public_path__ + "d0a24cf9494eb1e4324034324b93efb4.png";